import { createContext } from 'react';

import { ColorPalette } from '../../core/types/color-palette.js';
import { ColoredRange } from '../../core/types/colored-range.js';
import { DEFAULT_HONEYCOMB_COLOR_PALETTE } from '../constants.js';

export const HoneycombColorSchemeContext = createContext<
  ColorPalette | { [key: string]: string } | ColoredRange[] | string[]
>(DEFAULT_HONEYCOMB_COLOR_PALETTE);
